import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromPVCart, setCartOpen, updateCartItem } from "../../redux/pvDesign";
import { Form, Button } from "react-bootstrap";

const PVDesignCart = () => {
  const { cart, isCartOpen } = useSelector((s) => s.pvDesign);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  if (!isCartOpen || !cart?.length) return null;

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await new Promise((r) => setTimeout(r, 600));
      cart.forEach((c) => dispatch(removeFromPVCart(c.id)));
      dispatch(setCartOpen(false));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="pv-cart pv-anim-in">
      <div className="pv-cart-header">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span className="pv-modal-title-accent"/>
          <strong style={{ color: "#111827" }}>Selected designs</strong>
          <span className="pv-cart-counter">{cart.length}</span>
        </div>
      </div>
      <div className="pv-cart-list">
        {cart.map((item) => (
          <div key={item.id} className="pv-cart-item">
            <div style={{ display: "grid", gap: 6, alignItems: "center" }}>
              <Form.Control
                value={item.name || ''}
                onChange={(e) => dispatch(updateCartItem({ id: item.id, changes: { name: e.target.value } }))}
                className=""
                placeholder="Design name"
                type="text"
              />
            </div>
            <Button variant="danger" onClick={() => dispatch(removeFromPVCart(item.id))}  className="">Remove</Button>
          </div>
        ))}
      </div>
      <div className="pv-cart-actions">
        <Button variant="success" onClick={handleSubmit} disabled={isSubmitting} className="">
          {isSubmitting ? "Adding..." : "Add to PV scenarios"}
        </Button>
      </div>
    </div>
  );
};

export default PVDesignCart;


